import React from 'react';

import { useClientSmallScreen } from '@/lib/user-agent/client';

import Container from '@/components/@base/container';
import Section from '@/components/app/product/components/@shared/section';
import Props from '@/components/app/product/components/content/questions-summary/type';
import QuestionCard from '@/components/app/product/components/questions/question-card';
import QuestionHeader from '@/components/app/product/components/questions/question-header';

import { DATA_CY_PRODUCT_QUESTIONS_SUMMARY } from '@/constant/cypress';
import { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;

export default function QuestionsSummary({
  questions,
  rate,
  handleShowMoreQuestions,
  handleAddQuestionClick,
  ...props
}: Props) {
  const isSmallScreen = useClientSmallScreen();

  return (
    <Section
      data-cy={DATA_CY_PRODUCT_QUESTIONS_SUMMARY}
      id='questionsSection'
      className='mx-0!'
      expandable
      showMoreLabel={!isSmallScreen ? productLocalization.seeAllQuestions : undefined}
      onShowMoreClick={handleShowMoreQuestions}
      expandOnShowMoreClick={false}
    >
      <QuestionHeader rate={rate} onAddQuestionClick={handleAddQuestionClick} />
      {questions.map((question) => (
        <Container
          key={question.id}
          className='my-5 rounded-lg border-[1px] border-[#E9EBF1] p-[15px] last:mb-0 md:p-6'
        >
          <QuestionCard {...question} />
        </Container>
      ))}
    </Section>
  );
}
